import React, { createContext, useState, useEffect } from 'react';
import { remoteConfig } from '@ncl/config/firebase';

export const FlagContext = createContext({});

const FlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState({});

  useEffect(() => {
    async function fetchFlags() {
      try {
        await remoteConfig.fetchAndActivate();
        const remoteFlags = remoteConfig.getAll();
        setFlags(remoteFlags);
      } catch (error) {
        /* eslint-disable-next-line */
        console.log(error);
      }
    }

    fetchFlags();
  }, []);

  return <FlagContext.Provider value={flags}>{children}</FlagContext.Provider>;
};

export default FlagsProvider;
